<template>
  
      <div @click="play = !play" class="pointer click">
            <svg v-if="!play" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20Z" fill="white"/><rect x="7" y="7" width="6" height="6" rx="1" fill="#1C1C1C"/></svg>
            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20Z" fill="#CC4242"/><path d="M13.414 11.059L8.694 13.846C7.934 14.294 7 13.71 7 12.786V7.21396C7 6.28996 7.934 5.70696 8.694 6.15496L13.414 8.94196C14.195 9.40396 14.195 10.598 13.414 11.06" fill="white"/></svg>         
      </div>
  
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
      data() {
            return {
                  play: Boolean
            }
      },      
      mounted() {
            // 
      },
      props:{},
      methods: {
            
      },

});
</script>
